module.exports = __webpack_public_path__ + "static/media/compact-disc.2b156813.svg";